import { render, staticRenderFns } from "./StatsProdTotalHealth.vue?vue&type=template&id=505753cd&scoped=true&lang=html&"
import script from "./StatsProdTotalHealth.vue?vue&type=script&lang=js&"
export * from "./StatsProdTotalHealth.vue?vue&type=script&lang=js&"
import style0 from "./StatsProdTotalHealth.vue?vue&type=style&index=0&id=505753cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505753cd",
  null
  
)

export default component.exports